import React, { Component } from 'react';
import { connect } from 'react-redux';
import FilingReportTypeSelector from '../Generic/ReportTypeSelector';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import EcListingLineDetails from './LineDetails';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';
import ENUMS, {ECListingFlowPerTransactionTypesEnum, VATNumberChecksEnum, FeatureFlagEnum} from '../../../utils/enums';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import Pagination from '../../page/Pagination'
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import { CSVLink } from 'react-csv';
import dateformat from 'dateformat';

import _ from 'lodash';
import FILING_CONTROLLER from '../../../controllers/filing';

import Logger, {LOG_LEVELS} from '../../../utils/logger';
const log = new Logger('EC_LISTING_FILING_VALUES', LOG_LEVELS.DEBUG);

const modalStyle = {
  modal: 'modal-full-width-height modal-max-width-75',
};
const COUNTRY_CODE_CZ = 'CZ';
const LANGUAGE_PREFIX = 'ecListingFilingValues_';
class EcListingFilingValues extends Component {

  constructor(props) {
    super(props);
    this.state = Object.assign({}, this.state, { isLineDetailsPopupOpen: false, loading: false, lineVatNumber: null, isRequestIdSelected :true, ecListingLineDetailsParams: {}});
  }

  onCloseModal(){
    this.setState({ isLineDetailsPopupOpen: false });
  }

  onSelectReportType (event) {
    log.debug('onSelectReportType():', event);
    log.debug('onSelectReportType(): listingType: ', event.target.value);

    if(typeof this.props.onReportChangeHandler === 'function') {
      this.setState({ isRequestIdSelected: true });
      this.props.onReportChangeHandler ( {'selectedReportType': event.target.value });
    }
  }

  checkVATNumbers(criteria, msInterval) {
    log.debug("checkVATNumbers: criteria %s msInterval %s", criteria, msInterval );
    let requesterVATNumber = this.props.vatNumber;
    function onlyUnique(value,index,self) {
      return self.indexOf(value) === index;
    }

    let vrns = [];
    switch (criteria) {
      case 'all': {
        // Restrict to current table page only
        const lines = this.props.filingValues.lines || [];
        const page = (this.ecListingTableRef && this.ecListingTableRef.state && typeof this.ecListingTableRef.state.page === 'number')
          ? this.ecListingTableRef.state.page
          : 0;
        const pageSize = (this.ecListingTableRef && this.ecListingTableRef.state && this.ecListingTableRef.state.pageSize)
          ? this.ecListingTableRef.state.pageSize
          : 20;
        const start = page * pageSize;
        const currentPageLines = lines.slice(start, start + pageSize);
        vrns = currentPageLines.map(item => item.vatNumber).filter(onlyUnique);
        break;
      }
      case 'failed': {
        // Restrict to failed VAT numbers on current table page only
        const lines = this.props.filingValues.lines || [];
        const page = (this.ecListingTableRef && this.ecListingTableRef.state && typeof this.ecListingTableRef.state.page === 'number')
          ? this.ecListingTableRef.state.page
          : 0;
        const pageSize = (this.ecListingTableRef && this.ecListingTableRef.state && this.ecListingTableRef.state.pageSize)
          ? this.ecListingTableRef.state.pageSize
          : 20;
        const start = page * pageSize;
        const currentPageVrns = new Set(lines.slice(start, start + pageSize).map(item => item.vatNumber));
        const failedVrns = this.props.checkedVATNumbers && this.props.checkedVATNumbers.filter(item => !item.isValid).map(item => item.vrn) || [];
        vrns = failedVrns.filter(vrn => currentPageVrns.has(vrn)).filter(onlyUnique);
        break;
      }
      default:      // No criteria is a single VAT Number to check
        vrns = [criteria];
        msInterval = 0;
    }
    if (vrns && vrns.length > 0) {
      // Use a single interval to trigger one request at a time instead of N setTimeouts,
      // so the main thread stays responsive and each response updates the grid immediately.
      if (this._viesCheckIntervalId) {
        clearInterval(this._viesCheckIntervalId);
        this._viesCheckIntervalId = null;
      }
      const queue = vrns.slice();
      const useRequestId = this.state.isRequestIdSelected;
      this._viesCheckIntervalId = setInterval(() => {
        if (queue.length === 0) {
          clearInterval(this._viesCheckIntervalId);
          this._viesCheckIntervalId = null;
          return;
        }
        const vrn = queue.shift();
        if (useRequestId) {
          this.props.checkVATNumberWithRequestId(vrn, requesterVATNumber);
        } else {
          this.props.checkVATNumber(vrn);
        }
      }, msInterval);
    }
  }

  componentWillUnmount() {
    if (this._viesCheckIntervalId) {
      clearInterval(this._viesCheckIntervalId);
      this._viesCheckIntervalId = null;
    }
  }
    reliabilityCheckVATNumber()
    {
      //Add check to avoid multiple calls, if data available
      if(_.isEmpty(this.props.reliabilityCheckVATNumbers)) {
          function onlyUnique(value, index, self) {
              return self.indexOf(value) === index;
          }

          let vrns = this.props.filingValues.lines.map(item => item.vatNumber).filter(onlyUnique);

          log.debug("reliabilityCheckVATNumber", vrns);
          this.props.reliabilityCheckVATNumber(vrns);
      }
    }
  onRequestIdChangeHandler(){
     this.setState({ isRequestIdSelected: !this.state.isRequestIdSelected });
  }
  componentDidUpdate(prevProps) {
    if(!this.state.isRequestIdSelected && prevProps.frequency !== this.props.frequency){
      this.setState({ isRequestIdSelected: true });
    }
  }
  onDrilldown(row) {
    const lineData = row.original || {};
    const lineVatNumber = lineData.vatNumber;
    const lineDetails = (this.props.filingValues.lines && this.props.filingValues.lines[row.index]) || {};
    this.setState({lineVatNumber: lineVatNumber});
    const params = {
      countryCode: this.props.countryCode,
      companyId: this.props.companyId,
      startDate: this.props.filingPeriod && this.props.filingPeriod.fromDate,
      endDate: this.props.filingPeriod && this.props.filingPeriod.toDate,
      vatNumber: lineVatNumber || '',
      listingType: lineDetails.listingType,
      listingLineType: lineDetails.listingLineType,
      correctionDate: lineDetails.correctionDate,
      correctionKey: lineDetails.correctionKey,
      correctionType: lineDetails.correctionType
    };
    log.debug('onDrilldown(): params: ', params);
    this.setState({ecListingLineDetailsParams: params});
    if(this.props.featureFlags?.EnableECListingCorrectionLineDetails) {
      this.props.onShowEcListingLineDetails(params);
    } else {
      this.props.onShowEcListingDetails(params);
    }
    this.setState({isLineDetailsPopupOpen: true });

  }
    getColumns(columnData, ecListings) {
        const columns = columnData.map((item, id) => {
            return {
                id: item.accessor,
                Header: props => <LanguageStringResolver string={LANGUAGE_PREFIX + item.header.replace(/ +/g, "")} />,
                accessor:
                    (item.dataType === 'Currency')?
                        d =>  <FormattedCurrencyValue value={d[item.accessor]} inputFieldClassName={withFullStoryExclude()} /> : item.accessor,
                Footer: ( (item.accessor === 'vatNumber') ?
                    <div style={{width: '100%', textAlign: 'right'}}>
                        {<LanguageStringResolver string='ecListingFilingValues_TotalAmount' />}:&nbsp;
                    </div> :
                    (item.accessor === 'amount') ?
                    <p className={withFullStoryExclude("text-align-right")}>
                        {parseFloat(_.sum(_.map(ecListings, d => parseFloat(d.amount)))).toFixed(2)}
                    </p> : ''),
                Cell: (item.accessor === 'vatNumber') ?
                     row => (<button className="link" onClick={this.onDrilldown.bind(this, row)}>{row.value}</button>) :
                    (item.accessor === 'vatNumberCheck') ?
                    row => (
                      <span>
                        {row.original.vatNumberCheck === VATNumberChecksEnum.getValue("NOT_CHECKED") ? (
                            <button className="link" onClick={this.checkVATNumbers.bind(this,row.original.vatNumber)}>
                                <LanguageStringResolver string='ecListingFilingValues_CheckOnline' />
                            </button>
                        ) : row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED") ? (
                            <span><LanguageStringResolver string='ecListingFilingValues_FailedInvalidVATNumber' /></span>
                        ) : (
                            row.original.vatNumberCheck === VATNumberChecksEnum.getValue("OK") ? (
                                (row.original.requestIdentifier !== undefined)?
                                    <span>{row.original.viesCheckDateTime +  '-' }<LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")}/> { '-' + row.original.requestIdentifier}</span>
                                    :<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("OK")}/></span>
                            ) : (<span><LanguageStringResolver string='vatNumberCheckStatus_Unknown' /></span>)
                        )}
                      </span>
            ):'',
            }
        });
        return columns;
    }
  render() {
    log.debug('render(): ', this.props);
    const enableExportECListing = this.props.featureFlags?.[FeatureFlagEnum.ENABLE_EXPORT_ECLISTING];
    
    //Get lines
    const ecListings = this.props.filingValues.lines || [];
    const columnData = this.props.filingValues.columnData || [];
    let fileName = `ECListing_${new Date().toISOString().slice(0, 19).replace(/[-:]/g, "")}.csv`;

      const columnsToAdd = this.getColumns(columnData, ecListings);
      const extraInfoColumn =
          { Header: <span><LanguageStringResolver string='ecListingFilingValues_ExtraInfo' /></span>, accessor: 'extraInfo',
          Cell: row => (
          <span>
          {
              (row.original.vatNumberCheck === VATNumberChecksEnum.getValue("FAILED")) ? (
                      row.original.extraInfo === null
                          ? (<span><LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} /></span>)
                          : (
                              (row.original.extraInfo !== <LanguageStringResolver string={VATNumberChecksEnum.getLanguageString("FAILED")} />)
                                  ? (<span>{row.original.extraInfo}</span>)
                                  : (<span><LanguageStringResolver string='ecListingFilingValues_ServiceError'/>: {row.original.extraInfo}</span>)
                          )
                  )
                  : (<span>{row.original.extraInfo}</span>)
          }
          </span>
      )
      };

       //Add extraInfo column after company check
       let companyCheckIndex = columnsToAdd.map(function(e) { return e.accessor; }).indexOf('nameCheck');
       columnsToAdd.splice(companyCheckIndex+1, 0, extraInfoColumn);

      // Build lookup maps once so each row does O(1) lookup instead of O(n) filter – keeps render fast when many VIES results arrive.
      const checkedByVrn = {};
      (this.props.checkedVATNumbers || []).forEach((item) => { checkedByVrn[item.vrn] = item; });
      const inProgressSet = new Set(this.props.checkVATNumbersInProgress || []);

      let ecListingsData = ecListings.map((ecListingRow) => {

      let listingType = ENUMS.ValueToEnum(ecListingRow.listingType, ECListingFlowPerTransactionTypesEnum);
      let isSalesListingType = ENUMS.IsECListingFlowASalesTransaction(listingType);

      let ecListingCorrectionTypeAsStr = "";
      if(ecListingRow.correctionType === 0) {
        ecListingCorrectionTypeAsStr = <LanguageStringResolver string='ecListingCorrectionType_None' />;
      } else {
        ecListingCorrectionTypeAsStr = "True - " + dateformat(ecListingRow.correctionDate, 'mmm yyyy');
      }
      let lineCorrectionTypeLS = (this.props.lineCorrectionTypes[ecListingRow.correctionLineType + ""] && this.props.lineCorrectionTypes[ecListingRow.correctionLineType + ""].languageString) || '';
      let lineCorrectionType = lineCorrectionTypeLS === '' ? '' : <LanguageStringResolver string={lineCorrectionTypeLS} />;

      let ecTypeLS = (this.props.ecListingLineTypes[ecListingRow.listingLineType+''] && this.props.ecListingLineTypes[ecListingRow.listingLineType+''].languageString) || '';
      let ecType = ecTypeLS === '' ? '' : <LanguageStringResolver string={ecTypeLS} />;

      const checkResult = checkedByVrn[ecListingRow.vatNumber];
      let thisVATNumberIsValid = checkResult ? checkResult.isValid : undefined;

      // Construct extra data to populate the ecListingRow for VATNumberCheck details
      ecListingRow.VATNumberCheckDetails = {};

      switch (thisVATNumberIsValid){
        case true:
          ecListingRow.VATNumberCheckDetails.isValid = "";
          ecListingRow.VATNumberCheckDetails.companyName = checkResult.name;
          ecListingRow.VATNumberCheckDetails.extraInfo = checkResult.street + ', ' + checkResult.city;
          ecListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("OK");
          ecListingRow.VATNumberCheckDetails.requestIdentifier = checkResult.requestIdentifier;
          ecListingRow.VATNumberCheckDetails.viesCheckDateTime = checkResult.viesCheckDateTime;
          break;
        case false:
          ecListingRow.VATNumberCheckDetails.isValid = "false";
          ecListingRow.VATNumberCheckDetails.companyName = "";
          ecListingRow.VATNumberCheckDetails.extraInfo = checkResult.errorMessage;
          ecListingRow.vatNumberCheck = VATNumberChecksEnum.getValue("FAILED");
          ecListingRow.VATNumberCheckDetails.viesCheckDateTime = checkResult.viesCheckDateTime;
          break;
        default:
          ecListingRow.VATNumberCheckDetails.isValid = "";
          ecListingRow.VATNumberCheckDetails.companyName = "";
          ecListingRow.VATNumberCheckDetails.extraInfo = VATNumberChecksEnum.getString("NOT_CHECKED");
      }

      // Set status correctly for In Progress state
      if (inProgressSet.has(ecListingRow.vatNumber)) {
        ecListingRow.VATNumberCheckDetails.isValid = "";
        ecListingRow.VATNumberCheckDetails.companyName = "";
        ecListingRow.VATNumberCheckDetails.extraInfo = <LanguageStringResolver string='ecListingFilingValues_InProgress'/>;
      }

        // Construct extra data to populate the ecListingRow for reliability check
        log.debug('reliabilityCheckVATNumbers render(): ', this.props.reliabilityCheckVATNumbers);
        ecListingRow.reliabilityCheckVATNumbers = '';
        if(this.props.countryCode === COUNTRY_CODE_CZ && !_.isEmpty(this.props.reliabilityCheckVATNumbers)) {
            let checkReliabilityResultsForThisNumber = (this.props.reliabilityCheckVATNumbers && Object.values(this.props.reliabilityCheckVATNumbers.vatNumberReliabilityCheckStatus).filter(item => item.vatNumber === ecListingRow.vatNumber )) || []
            if(!_.isEmpty(checkReliabilityResultsForThisNumber))
              ecListingRow.reliabilityCheckVATNumbers = checkReliabilityResultsForThisNumber[0].status;
        }
      return {
        vatNumber: ecListingRow.vatNumber,
        amount: ecListingRow.amount,
        listingLineType: ecType,
        correctionType: ecListingCorrectionTypeAsStr,
        listingType:  (isSalesListingType) ? (
          <LanguageStringResolver string='ecListingTypeValue_Out'/>
        ) : (
          <LanguageStringResolver string='ecListingTypeValue_In'/>
        ),
        correctionLineType: lineCorrectionType,
        vatNumberCheck: ecListingRow.vatNumberCheck,
        name:  isSalesListingType ? ecListingRow.name : ecListingRow.supplierName,
        nameCheck: ecListingRow.VATNumberCheckDetails.companyName,
        extraInfo: ecListingRow.VATNumberCheckDetails.extraInfo,
        requestIdentifier:ecListingRow.VATNumberCheckDetails.requestIdentifier,
        payerCZReliability :ecListingRow.reliabilityCheckVATNumbers,
        currencyPartner: ecListingRow.currencyPartner,
        amountPartnerCurrency: ecListingRow.amountPartnerCurrency,
        supplierInvoiceNumber: ecListingRow.supplierInvoiceNumber,
        invoiceNumber: ecListingRow.invoiceNumber,
        countryPayment: ecListingRow.countryPayment,
        serviceCode: ecListingRow.serviceCode,
        viesCheckDateTime:ecListingRow.VATNumberCheckDetails.viesCheckDateTime
      };
    });

    const prepareCSVData = (ecListingsData) => {
      const rows = ecListingsData.map(row => ({
        vatNumber: row.vatNumber || '',
        amount: row.amount || '',
        listingLineType: typeof row.listingLineType === 'object' ?
          LANGUAGES_CONTROLLER.format(this.props.languages, row.listingLineType.props.string) :
          row.listingLineType || '',
        correctionType: typeof row.correctionType === 'object' ?
          LANGUAGES_CONTROLLER.format(this.props.languages, row.correctionType.props.string) :
          row.correctionType || '',
        listingType: typeof row.listingType === 'object' ?
          LANGUAGES_CONTROLLER.format(this.props.languages, row.listingType.props.string) :
          row.listingType || '',
        correctionLineType: typeof row.correctionLineType === 'object' ?
          LANGUAGES_CONTROLLER.format(this.props.languages, row.correctionLineType.props.string) :
          row.correctionLineType || '',
        name: row.name || '',
        nameCheck: row.nameCheck || '',
        extraInfo: typeof row.extraInfo === 'object' ?
          LANGUAGES_CONTROLLER.format(this.props.languages, row.extraInfo.props.string) :
          row.extraInfo || '',
        supplierInvoiceNumber: row.supplierInvoiceNumber || '',
        invoiceNumber: row.invoiceNumber || '',
        viesCheckDateTime: row.viesCheckDateTime ? `${row.viesCheckDateTime}-Passed-${row.requestIdentifier ?? ''}` : ''
      }));
    
      const totalAmount = ecListingsData.reduce((sum, row) => {
        const amount = parseFloat(row.amount) || 0;
        return sum + amount;
      }, 0);
    
      const totalRow = {
        vatNumber: '',
        amount: 'Total Amount:  '+ totalAmount.toString(),
        listingLineType: '',
        correctionType: '',
        listingType: '',
        correctionLineType: '',
        name: '',
        nameCheck: '',
        extraInfo: '',
        supplierInvoiceNumber: '',
        invoiceNumber: '',
        viesCheckDateTime: '',
      };
    
      return [...rows, totalRow];
    };
    
    const csvHeaders = [
      { label: 'VAT Number', key: 'vatNumber' },
      { label: 'Total Amount', key: 'amount' },
      { label: 'EC Type', key: 'listingLineType' },
      { label: 'Correction', key: 'correctionType' },
      { label: 'In/Out', key: 'listingType' },
      { label: 'Type', key: 'correctionLineType' },
      { label: 'Company', key: 'name' },
      { label: 'VIES Check', key: 'viesCheckDateTime' },
      { label: 'Company Name Check', key: 'nameCheck' },
      { label: 'Extra Info', key: 'extraInfo' },
      { label: 'Invoice Nr', key: 'invoiceNumber' },
      { label: 'Supplier Invoice Nr', key: 'supplierInvoiceNumber' }
    ];

    const csvData = prepareCSVData(ecListingsData);
    const loading = Boolean(this.props.loading);

    return (
      <div>
        <div>
          <s-row>
            <s-col span="6">
              <div className="mb20">
                <FilingReportTypeSelector flowTypes={Object.keys(ECListingFlowPerTransactionTypesEnum.props)} selectValue={this.props.selectedReportType}
                  onChange={(e) => this.onSelectReportType(e)}></FilingReportTypeSelector>
              </div>
              <div className="mb20">
                <button className="link" onClick={this.checkVATNumbers.bind(this, 'all', 150)} >
                  <LanguageStringResolver string='ecListingFilingValues_CheckCurrentTableVATNumbers' />
                </button>
                { (() => {
                  const failedVrns = this.props.checkedVATNumbers && this.props.checkedVATNumbers.filter(item => !item.isValid).map(item => item.vrn) || [];
                  if (failedVrns.length === 0) return <span></span>;
                  const lines = this.props.filingValues.lines || [];
                  const page = (this.ecListingTableRef && this.ecListingTableRef.state && typeof this.ecListingTableRef.state.page === 'number')
                    ? this.ecListingTableRef.state.page
                    : 0;
                  const pageSize = (this.ecListingTableRef && this.ecListingTableRef.state && this.ecListingTableRef.state.pageSize)
                    ? this.ecListingTableRef.state.pageSize
                    : 20;
                  const start = page * pageSize;
                  const currentPageVrns = new Set(lines.slice(start, start + pageSize).map(item => item.vatNumber));
                  const hasFailedOnCurrentPage = failedVrns.some(vrn => currentPageVrns.has(vrn));
                  if (!hasFailedOnCurrentPage) return <span></span>;
                  return (
                    <span>
                      <span className="divider-left margin-left-sm margin-right-sm"></span>
                      <button className="tertiary" onClick={this.checkVATNumbers.bind(this, 'failed', 150)}>
                        <LanguageStringResolver string='ecListingFilingValues_CheckCurrentTableFailed' />
                      </button>
                    </span>
                  );
                })() }
                <span className="divider-left margin-left-sm margin-right-sm"></span>
                <fieldset className="inline">
                  <input className="checkbox" type="checkbox" id="r1" checked ={this.state.isRequestIdSelected} onClick={this.onRequestIdChangeHandler.bind(this)} aria-checked="false" />
                  <label className="checkbox"><LanguageStringResolver string='ecListingFilingValues_RequestID' /></label>
                </fieldset>
                  {(this.props.countryCode === COUNTRY_CODE_CZ) ?
                      ( <span>
                          <span className="divider-left margin-left-sm margin-right-sm"></span>
                          <button className="tertiary" onClick={this.reliabilityCheckVATNumber.bind(this)} >
                              <LanguageStringResolver string='ecListingFilingValues_CheckReliability' />
                          </button>
                        </span>)
                      : <span></span>
                  }
              </div>
            </s-col>
          </s-row>
          {loading ? (
            <div className="mb30" data-testid="ec-listing-values-loading">
              <s-loader size="lg" loading=""></s-loader>
              <p><LanguageStringResolver string='xmlUriViwer_loading' /></p>
            </div>
          ) : (
            <>
          <ReactTable
            ref={ref => { this.ecListingTableRef = ref; }}
            data={ecListingsData}
            columns={columnsToAdd}
            minRows={0}
            maxRows={0}
            className={_.isEmpty(ecListingsData) ? '-striped -highlight header-no-filters' : '-striped -highlight header-no-filters mb30'}
            noDataText={<LanguageStringResolver string='ecListingFilingValues_NoData'/>}
            resizable={true}
            sortable={false}
            defaultPageSize={20}
            pageSizeOptions={[ 20, 50, 100, 1000]}
            showPagination={ecListings.length !== 0}
            PaginationComponent={Pagination}
          />
          {enableExportECListing && <CSVLink
            data={sanitizeCsvData(csvData)}
            headers={csvHeaders}
            filename={fileName}
            className={ecListingsData && ecListingsData.length > 0 ? "button secondary" : "invisible"}
          >
            <LanguageStringResolver string='ecListingView_ExportToCSV' />
          </CSVLink>}
            </>
          )}

        </div>
        <div>
            <Modal open={this.state.isLineDetailsPopupOpen} onClose={this.onCloseModal.bind(this)} classNames={modalStyle}>
              <div>
                 <h2><LanguageStringResolver string='ecListingRowDrilldown_title'/></h2>
                <s-row>
                  <s-col span="12">
                    <EcListingLineDetails params={this.state.ecListingLineDetailsParams}/>
                  </s-col>
                </s-row>
            </div>
            </Modal>
          </div>
      </div>
    );
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps(): ', state);
  return {
    lineCorrectionTypes: (state.content && state.content.data && state.content.data.ecListingLineCorrectionTypes) || {},
    vatNumberCheckStatuses: (state.content && state.content.data && state.content.data.vatNumberCheckStatuses) || {},
    ecListingLineTypes: (state.content && state.content.data && state.content.data.ecListingLineTypes) || {},
    checkedVATNumbers: state.filing.checkedVATNumbers,
    checkVATNumbersInProgress: state.filing.checkVATNumbersInProgress || [],
    reliabilityCheckVATNumbers: state.filing.reliabilityCheckVATNumbers || {},
    featureFlags: state.featureFlag && state.featureFlag.data
  }
}

function mapDispatchersToProps(dispatch) {
  return {
    checkVATNumber: (vatNumber) => {
      log.debug("checkVATNumber: vatNumber: ", vatNumber);
      dispatch(FILING_CONTROLLER.checkVATNumber(vatNumber))
    },
    checkVATNumberWithRequestId: (vatNumber, requesterVATNumber) => {
      log.debug("checkVATNumber: vatNumber: requesterVATNumber", vatNumber,requesterVATNumber);
      dispatch(FILING_CONTROLLER.checkVATNumberWithRequestId(vatNumber, requesterVATNumber))
    },
    onShowEcListingDetails: (params) => {
      log.debug('onShowEcListingDetails: ', params);
      dispatch(FILING_CONTROLLER.doLoadEcListingDetails(params));
    },
    onShowEcListingLineDetails: (params) => {
      log.debug('onShowEcListingLineDetails: ', params);
      dispatch(FILING_CONTROLLER.doLoadEcListingLineDetails(params));
    },
      reliabilityCheckVATNumber: (vatNumbers) => {
          log.debug("reliabilityCheckVATNumber: vatNumber: ", vatNumbers);
          dispatch(FILING_CONTROLLER.reliabilityCheckVATNumber(vatNumbers))
     },
  };
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(EcListingFilingValues);
